import React from 'react';
import Page from '../../lib/page';
import env from '../../lib/env';
import { Button } from 'antd';
import mis_pic from '../../asset/404.png';

export default class Page404 extends Page {
    render() {
        return (
        <div style={{
            width:'1000px',
            margin:'0 auto',
            padding: '144px 106px', 
            position: 'relative',
        }}>
            <div style={{
                width: '347px',     
                height: '226px',     
                backgroundImage: `url(${mis_pic})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                float: "left",
            }}
            />
            <div style={{
                float: 'right',
            }}>
                <div style={{
                   fontSize: '73px',
                   fontWeight: 'bold',
                   lineHeight: '73px',
                   paddingTop: '24px',
                }}>404</div>
                <div style={{
                    fontSize: '20px', 
                    lineHeight: '28px', 
                    color: '#999999',
                    padding: '24px 0 16px 0',
                }}>抱歉，你访问的页面不存在</div>
                <Button type="primary" onClick={() => {
                    env.goto_page('/'); 
                }}>返回首页</Button>
            </div>
           <div style={{clear: 'both'}} /> 
        </div>        
        );
    }
}



// WEBPACK FOOTER //
// ./src/layout/error/404.js